import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-employer-info',
  templateUrl: './employer-info.component.html'
})
export class EmployerInfoComponent implements OnInit {
  @Output()
  formReady = new EventEmitter<FormGroup>();

  @Input() employer: any;

  constructor(private fb: FormBuilder) { }

  form = this.fb.group({});

  ngOnInit(): void {
    for(let field of this.formFields){
      let formControl = new FormControl('',field.validation)
      this.form.addControl(field.formControlName, formControl);
    }
    this.formReady.emit(this.form);
    if(this.employer){
      this.form.patchValue(this.employer);
    }
  }

  formFields = [
    {
      title: "Nombre del Patrono",
      formControlName: "employerName",
      type: "text",
      validation: [Validators.required]
    },
    {
      title: "Años de Empleo",
      formControlName: "employeedYears",
      type: "number",
      validation: [Validators.required]
    },
    {
      title: "Posición o Título",
      formControlName: "position",
      type: "text",
      validation: [Validators.required]
    },
    {
      title: "Teléfono",
      formControlName: "employeerPhone",
      type: "tel",
      validation: [Validators.required]
    },
    {
      title: "Dirección del Patrono",
      formControlName: "employeerAddress",
      type: "text",
      validation: [Validators.required]
    },
    {
      title: "Supervisor",
      formControlName: "employeerSupervisor",
      type: "text",
      validation: [Validators.required]
    },
    {
      title: "Ingreso Mensual",
      formControlName: "monthlyIncome",
      type: "number",
      validation: [Validators.required]
    },
    {
      title: "Otro Ingresos: Descripción",
      formControlName: "otherIncomeDesc",
      type: "text",
      validation: null
    },
    {
      title: "Otro Ingresos: Cantidad",
      formControlName: "otherIncomeAmount",
      type: "number",
      validation: null
    }
  ]

}
